import React from 'react'
import TechnicalServicePage from '../components/TechnicalServicePage'

const SpatialOmicsPage = () => {
  return <TechnicalServicePage serviceKey="spatialOmics" />
}

export default SpatialOmicsPage
